import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-jsx'
import 'ace-builds/src-noconflict/theme-xcode'
import { useGetViewVersion } from '../../../../../api/abundanceEngine'
import Loading from '../../../../molecules/Loading'
import ContentPreviewView from './ViewContentContainer/ContentPreviewView'
import VersionSelect from './VersionSelect'

const useStyles = makeStyles(() => ({
  pane: {
    border: '5px solid var(--color-neutral-300)'
  },
  paneLabel: {
    fontSize: '0.65rem',
    fontWeight: 'var(--font-weight-bold)',
    textTransform: 'uppercase',
    color: 'var(--color-neutral-500)',
    letterSpacing: '0.05em'
  }
}))

function ComparePane ({ viewId, viewMode }) {
  const classes = useStyles()
  const [versionId, setVersionId] = useState(null)
  const { data: versionData, isFetching } = useGetViewVersion(versionId, { enabled: !!versionId })
  const content = versionData?.content

  return (
    <div className={`${classes.pane} flex-1 flex flex-col overflow-hidden min-w-0 radius-lg`}>
      <div
        className='flex items-center gap-2 py-1 px-2 bg-neutral-050 shrink-0'
        style={{ borderBottom: '1px solid var(--color-neutral-200)' }}
      >
        <span className={`${classes.paneLabel} shrink-0`}>Reference</span>
        <div className='flex-1 min-w-0'>
          <VersionSelect
            viewId={viewId}
            value={versionId}
            onChange={setVersionId}
            placeholder='Select version'
            size='sm'
          />
        </div>
      </div>
      <div className='flex-1 overflow-hidden relative'>
        {isFetching && (
          <div className='flex items-center justify-center h-full gap-2 font-size-xs' style={{ color: 'var(--color-neutral-500)' }}>
            <Loading size={16} />
            <span>Loading...</span>
          </div>
        )}
        {!isFetching && !content && (
          <div className='flex items-center justify-center h-full font-size-sm' style={{ color: 'var(--color-neutral-400)', fontStyle: 'italic' }}>Select a version to compare</div>
        )}
        {!isFetching && content && viewMode === 'code' && (
          <AceEditor
            height='100%'
            width='100%'
            mode='jsx'
            theme='xcode'
            name='compare-reference'
            value={content}
            readOnly
            showPrintMargin={false}
            showGutter
            highlightActiveLine={false}
            tabSize={2}
            setOptions={{ useWorker: false }}
            editorProps={{ $blockScrolling: true }}
          />
        )}
        {!isFetching && content && viewMode === 'preview' && (
          <ContentPreviewView jsxContent={content} />
        )}
      </div>
    </div>
  )
}

ComparePane.propTypes = {
  viewId: PropTypes.number,
  viewMode: PropTypes.string.isRequired
}

export default ComparePane
